import { render, staticRenderFns } from "./CarePlusDashboard.vue?vue&type=template&id=234f4f56&"
import script from "./CarePlusDashboard.vue?vue&type=script&lang=js&"
export * from "./CarePlusDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CarePlusDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports